<template>
  <div class="modal fade" id="editAccountD" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div class="text-center mb-8">
            <h4>Edit Account Details</h4>
          </div>
          <form id="editAccountDForm" class="row g-4">
            <div class="col-12">
              <label class="form-label" for="username">Username</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-at"></i></div>
                <input
                  type="text"
                  id="username"
                  class="form-control"
                  placeholder="Username"
                />
                <span class="input-group-text" id="basic-addon13"
                  >@highspeed.com.tr</span
                >
              </div>
            </div>

            <div class="col-12">
              <label class="form-label" for="password">Password</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-lock"></i></div>
                <input
                  type="password"
                  class="form-control"
                  id="basic-default-password12"
                  placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                  aria-describedby="basic-default-password2"
                />
                <span
                  id="basic-default-password2"
                  class="input-group-text cursor-pointer"
                  ><i class="ti ti-eye-off"></i
                ></span>
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="agent">Account Agent</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-user-shield"></i>
                </div>
                <input
                  type="text"
                  id="agent"
                  class="form-control"
                  placeholder="Enter Agent Name"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="devices">Allowed Devices</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-device-laptop"></i>
                </div>
                <input
                  type="number"
                  id="devices"
                  class="form-control"
                  placeholder="e.g. 2"
                  min="1"
                />
              </div>
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label" for="country">Country</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-flag"></i></div>
                <select id="country" class="form-select">
                  <option selected disabled>Select Country</option>
                  <option value="turkey">Turkey</option>
                  <option value="syria">Syria</option>
                  <option value="other">Other</option>
                </select>
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="state">State</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-map-pin"></i>
                </div>
                <select id="state" class="form-select">
                  <option selected disabled>Select State</option>
                  <option value="hatay">Hatay</option>
                  <option value="gaziantep">Gaziantep</option>
                </select>
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="city">City</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-building-community"></i>
                </div>
                <select id="city" class="form-select">
                  <option selected disabled>Select City</option>
                  <option value="antakya">Antakya</option>
                  <option value="iskenderun">İskenderun</option>
                </select>
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="neighborhood">Neighborhood</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-building"></i>
                </div>
                <select id="neighborhood" class="form-select">
                  <option selected disabled>Select Neighborhood</option>
                  <option value="kuraya">Saraykent</option>
                  <option value="center">City Center</option>
                </select>
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="street">Street</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-road"></i></div>
                <select id="street" class="form-select">
                  <option selected disabled>Select Street</option>
                  <option value="kuraya_st">Koraya Street</option>
                  <option value="sukak_1">Sokak 1</option>
                </select>
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="addressDetails"
                >Address Details</label
              >
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-home"></i></div>
                <input
                  type="text"
                  id="addressDetails"
                  class="form-control"
                  placeholder="House No., Apartment, etc."
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="longitude">Longitude</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-navigation"></i>
                </div>
                <input
                  type="text"
                  id="longitude"
                  class="form-control"
                  placeholder="Longitude"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="latitude">Latitude</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-navigation-up"></i>
                </div>
                <input
                  type="text"
                  id="latitude"
                  class="form-control"
                  placeholder="Latitude"
                />
              </div>
            </div>
            <div class="col-12 text-center mt-8">
              <button
                type="button"
                class="btn btn-primary me-3"
                @click="submitAccountDetailsChanges"
              >
                Submit
              </button>
              <button
                type="reset"
                class="btn btn-label-secondary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="tempSpeedModal" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body p-4">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div class="text-center mb-6">
            <h4 class="mb-2">Temporary Speed Change</h4>
          </div>
          <form id="temporarySpeedForm" class="row g-4">
            <div class="col-12">
              <label class="form-label" for="duration">Duration</label>
              <div class="input-group">
                <span class="input-group-text"
                  ><i class="ti ti-clock"></i
                ></span>
                <input
                  type="number"
                  id="duration"
                  class="form-control"
                  placeholder="Enter duration"
                  min="1"
                />
                <select
                  id="durationUnit"
                  class="form-select"
                  style="max-width: 120px;"
                >
                  <option value="hours">Hours</option>
                  <option value="days">Days</option>
                </select>
              </div>
            </div>

            <div class="col-12">
              <label class="form-label" for="downloadSpeed"
                >Download Speed (Mbps)</label
              >
              <div class="input-group">
                <span class="input-group-text"
                  ><i class="ti ti-download"></i
                ></span>
                <input
                  type="number"
                  id="downloadSpeed"
                  class="form-control"
                  placeholder="e.g. 4"
                  min="1"
                />
              </div>
            </div>

            <div class="col-12">
              <label class="form-label" for="uploadSpeed"
                >Upload Speed (Mbps)</label
              >
              <div class="input-group">
                <span class="input-group-text"
                  ><i class="ti ti-upload"></i
                ></span>
                <input
                  type="number"
                  id="uploadSpeed"
                  class="form-control"
                  placeholder="e.g. 1"
                  min="1"
                />
              </div>
            </div>

            <div class="col-12 text-center mt-5">
              <button
                type="button"
                class="btn btn-primary me-3"
                @click="submitTemporarySpeedChange"
              >
                Apply Change
              </button>
              <button
                type="reset"
                class="btn btn-label-secondary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="container-xxl flex-grow-1 container-p-y">
    <div class="col-md-12">
      <div class="card mb-6">
        <div
          class="card-header d-flex align-items-center justify-content-between"
        >
          <h3 class="mb-0">Personal Information</h3>
        </div>
        <div class="card-body pt-4">
          <form id="editUserForm" class="row g-6" onsubmit="return false">
            <div class="col-12 col-md-6">
              <label class="form-label" for="firstName">First Name</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-user"></i></div>
                <input
                  type="text"
                  id="firstName"
                  class="form-control"
                  placeholder="First Name"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="lastName">Last Name</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-user-plus"></i>
                </div>
                <input
                  type="text"
                  id="lastName"
                  class="form-control"
                  placeholder="Last Name"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="fatherName">Father's Name</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-man"></i></div>
                <input
                  type="text"
                  id="fatherName"
                  class="form-control"
                  placeholder="Father's Name"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="motherName">Mother's Name</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-woman"></i>
                </div>
                <input
                  type="text"
                  id="motherName"
                  class="form-control"
                  placeholder="Mother's Name"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="nationalId">National ID</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-id"></i></div>
                <input
                  type="text"
                  id="nationalId"
                  class="form-control"
                  placeholder="National ID"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="mobileNumber">Mobile Number</label>
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-device-mobile"></i>
                </div>
                <input
                  type="text"
                  id="mobileNumber"
                  class="form-control"
                  placeholder="Mobile Number"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="landlineNumber"
                >Landline Number</label
              >
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-phone"></i>
                </div>
                <input
                  type="text"
                  id="landlineNumber"
                  class="form-control"
                  placeholder="Landline Number"
                />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="email">Email</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-mail"></i></div>
                <input
                  type="email"
                  id="email"
                  class="form-control"
                  placeholder="Email"
                />
              </div>
            </div>

            <div class="col-12">
              <label class="form-label" for="notes">Notes</label>
              <div class="input-group">
                <div class="input-group-text"><i class="ti ti-note"></i></div>
                <textarea
                  id="notes"
                  class="form-control"
                  rows="2"
                  placeholder="Additional notes"
                ></textarea>
              </div>
            </div>

            <div class="col-12 text-center">
              <button
                type="button"
                class="btn btn-primary me-3"
                @click="submitAccountChanges"
              >
                Submit
              </button>
              <button
                type="reset"
                class="btn btn-label-secondary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
        <!-- /Account -->
      </div>
    </div>

    <div class="card mb-6">
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <div
              class="alert alert-dark d-flex align-items-center"
              role="alert"
            >
              <span class="alert-icon rounded me-2">
                <i class="ti ti-hash"></i>
              </span>
              Serial Number:
              <strong class="ms-2">123456</strong>
            </div>
          </div>

          <div class="col-md-4">
            <div
              class="alert alert-dark d-flex align-items-center"
              role="alert"
            >
              <span class="alert-icon rounded me-2">
                <i class="ti ti-at"></i>
              </span>
              Username:
              <strong class="ms-2">mhana</strong>
            </div>
          </div>

          <div class="col-md-4">
            <div
              class="alert alert-dark d-flex align-items-center"
              role="alert"
            >
              <span class="alert-icon rounded me-2">
                <i class="ti ti-lock"></i>
              </span>
              Password:
              <strong class="ms-2">••••••</strong>
            </div>
          </div>

          <div class="col-md-3">
            <div
              class="alert alert-dark d-flex align-items-center"
              role="alert"
            >
              <span class="alert-icon rounded me-2">
                <i class="ti ti-user-shield"></i>
              </span>
              Account Agent:
              <strong class="ms-2">agent_name</strong>
            </div>
          </div>

          <div class="col-md-3">
            <div
              class="alert alert-dark d-flex align-items-center"
              role="alert"
            >
              <span class="alert-icon rounded me-2">
                <i class="ti ti-device-laptop"></i>
              </span>
              Allowed Devices:
              <strong class="ms-2">2 Devices</strong>
            </div>
          </div>
          <div class="col-md-6">
            <div
              class="alert alert-dark d-flex align-items-center"
              role="alert"
            >
              <span class="alert-icon rounded me-2">
                <i class="ti ti-map-pin"></i>
              </span>
              Address:
              <strong class="ms-2"
                >Hatay, Antakya, Kuraya Sokak, House No. 5</strong
              >
            </div>
          </div>
        </div>

        <div class="d-grid w-100 mt-4">
          <button
            class="btn btn-primary"
            data-bs-target="#editAccountD"
            data-bs-toggle="modal"
          >
            <i class="ti ti-edit ti-xs me-2"></i>
            <span>Edit Account Details</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card mb-6 ">
      <div
        class="card-header d-flex justify-content-between align-items-center"
      >
        <div>
          <h4 class="mb-1">Account Location</h4>
        </div>
      </div>

      <div class="card-body">
        <GMapMap
          :center="{ lat: lat, lng: lng }"
          :zoom="15"
          style="width: 100%; height: 400px"
        >
          <GMapMarker
            :position="{ lat: lat, lng: lng }"
            :icon="{
              url: require('@/assets/img/map/1.svg'), // أيقونة مخصصة (ضع صورتك هنا)
              scaledSize: { width: 80, height: 80 },
            }"
          />
        </GMapMap>

        <!-- زر فتح في خرائط Google -->
        <a
          class="btn btn-primary mt-3 w-100"
          :href="`https://www.google.com/maps?q=${lat},${lng}`"
          target="_blank"
          rel="noopener noreferrer"
        >
          Open in Google Maps
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      lat: 41.016285,
      lng: 28.656916,
    };
  },
  methods: {
    confirmDisconnect() {
      this.$swal({
        title: "Are you sure?",
        text: "This will disconnect the user from the internet.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, disconnect",
        cancelButtonText: "No",
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.$swal({
              title: "Disconnected!",
              text: "The user has been disconnected from the internet.",
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: "Error",
              text:
                error.response?.data?.message ||
                "Something went wrong. Please try again later.",
              icon: "error",
              confirmButtonText: "OK",
              backdrop: true,
            });
          }
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          this.$swal({
            title: "Cancelled",
            text: "The operation was cancelled.",
            icon: "error",
            timer: 1500,
            showConfirmButton: false,
            backdrop: true,
          });
        }
      });
    },
    confirmRenewManual() {
      this.$swal({
        title: "Are you sure?",
        text: "This will set the subscription to manual renewal.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, set to Manual",
        cancelButtonText: "No",
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-warning",
          cancelButton: "btn btn-label-secondary",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.$swal({
              title: "Updated!",
              text: "Subscription is now set to manual renewal.",
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: "Error",
              text:
                error.response?.data?.message ||
                "Something went wrong. Please try again later.",
              icon: "error",
              confirmButtonText: "OK",
              backdrop: true,
            });
          }
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          this.$swal({
            title: "Cancelled",
            text: "The operation was cancelled.",
            icon: "error",
            timer: 1500,
            showConfirmButton: false,
            backdrop: true,
          });
        }
      });
    },
    confirmRenewAuto() {
      this.$swal({
        title: "Are you sure?",
        text: "This will set the subscription to auto renewal.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, set to Auto",
        cancelButtonText: "No",
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-warning",
          cancelButton: "btn btn-label-secondary",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.$swal({
              title: "Updated!",
              text: "Subscription is now set to auto renewal.",
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: "Error",
              text:
                error.response?.data?.message ||
                "Something went wrong. Please try again later.",
              icon: "error",
              confirmButtonText: "OK",
              backdrop: true,
            });
          }
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          this.$swal({
            title: "Cancelled",
            text: "The operation was cancelled.",
            icon: "error",
            timer: 1500,
            showConfirmButton: false,
            backdrop: true,
          });
        }
      });
    },
    confirmAdd2FreeDays() {
      this.$swal({
        title: "Add 2 Free Days?",
        text: "This will extend the subscription by 2 free days.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, add 2 days",
        cancelButtonText: "No",
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-primary",
          cancelButton: "btn btn-label-secondary",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.$swal({
              title: "Success!",
              text: "2 free days were added to the subscription.",
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: "Error",
              text:
                error.response?.data?.message ||
                "Something went wrong. Please try again later.",
              icon: "error",
              confirmButtonText: "OK",
              backdrop: true,
            });
          }
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          this.$swal({
            title: "Cancelled",
            text: "The operation was cancelled.",
            icon: "error",
            timer: 1500,
            showConfirmButton: false,
            backdrop: true,
          });
        }
      });
    },
    submitAccountDetailsChanges() {
      try {
        const modalElement = document.getElementById("editAccountD");
        if (modalElement) {
          const modalInstance = bootstrap.Modal.getInstance(modalElement);
          if (modalInstance) {
            modalInstance.hide();
          }
        }

        this.$swal({
          icon: "success",
          title: "Changes saved successfully!",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Error while saving changes",
          text: error.response?.data?.message || "Please try again later.",
          confirmButtonText: "OK",
        });
      }
    },
    submitTemporarySpeedChange() {
      try {
        const modalElement = document.getElementById("tempSpeedModal");
        if (modalElement) {
          const modalInstance = bootstrap.Modal.getInstance(modalElement);
          if (modalInstance) {
            modalInstance.hide();
          }
        }

        this.$swal({
          icon: "success",
          title: "Temporary speed updated!",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Error while applying speed change",
          text: error.response?.data?.message || "Please try again later.",
          confirmButtonText: "OK",
        });
      }
    },
  },
};
</script>
